import React from "react";
import Maze from "../../Maze";

const Screen25 = () => {
    return <Maze />;
};

export default Screen25;
